import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";
import sellarLogo from "../../images/sellar-logo-white.png";

export const SellarWhiteLogoPurpleLogo = ({
  className,
}: {
  className?: string;
}): ReactElement => {
  return (
    <div
      className={twMerge(
        "flex h-6 w-6 items-center justify-center rounded-sm bg-[#B557F1]",
        className,
      )}
    >
      <img src={sellarLogo} className={"h-4 w-4"} />
    </div>
  );
};
